var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 2.15869C6.14091 2.15869 2.77637 5.52323 2.77637 9.6736C2.77637 13.824 6.14091 17.1885 10.2913 17.1885C14.4416 17.1885 17.8062 13.824 17.8062 9.6736C17.8062 5.52323 14.4416 2.15869 10.2913 2.15869ZM14.1245 6.342C14.2728 6.49029 14.2728 6.73073 14.1245 6.87903L11.3299 9.6736L14.1245 12.4682C14.2728 12.6165 14.2728 12.8569 14.1245 13.0052L13.6229 13.5069C13.4746 13.6552 13.2341 13.6552 13.0858 13.5069L10.2913 10.7123L7.49671 13.5068C7.34841 13.6551 7.10797 13.6551 6.95967 13.5068L6.45801 13.0052C6.30971 12.8569 6.30971 12.6164 6.45801 12.4681L9.25258 9.67358L6.45801 6.87903C6.30971 6.73073 6.30971 6.49029 6.45801 6.342L6.95967 5.84034C7.10797 5.69204 7.34841 5.69204 7.49671 5.84034L10.2913 8.6349L13.0858 5.84034C13.2341 5.69204 13.4746 5.69204 13.6229 5.84034L14.1245 6.342Z",
    fill: "#FF3D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d5ef38eff5141d3cae6f11e37ad0d4e6.svg";
export { ForwardRef as ReactComponent };